import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment-timezone';

import { PageHeader } from '../../../components/PageHeader';
import Select from '../../../components/Select';
import { GET_DEVICES_REPORT_INITIAL_REQ_RESULT, GET_DEVICES_REPORT_RECURRING_REQ_RESULT, GET_DEVICES_REPORT_REQ_RESULT, GET_REPORT_REQ_RESULT, actions } from './redux/actions';
import Strings from '../../../Strings';
import { notificationActions } from '../../../components/Notification/redux/actions';

import './Report.scss';
import { downloadFileOnly, downloadXlsx } from '../../../utils';
import ReportDashboard from './ReportDashboard';
import { hasPermission, PERMISSIONS } from '../../../utils/userPermissions';
import { isSuperUser } from '../../../utils/userRoles';
import DropdownMenu from '../../../components/DropdownMenu/DropdownMenu';
import { openModalAction } from '../../../actions/modal';

export function getDefaultPeriods() {
  const currentDate = moment();
  let year = currentDate.year();
  let month = currentDate.month() + 1;

  const periods = [
    {
      label: year.toString() + '/' + month.toString(),
      value: currentDate.format(),
      start: moment()
        .startOf('month')
        .format(),
      end: currentDate.format(),
    },
  ];

  for (let i = 6; i > 0; i -= 1) {
    month -= 1;
    if (month === 0) {
      month = 12;
      year -= 1;
    }

    const timestamp = moment({ year, month: month - 1, day: 1 })
      .endOf('month')
      .format();

    periods.push({
      label: year.toString() + '/' + month.toString(),
      value: timestamp,
      start: moment(timestamp)
        .startOf('month')
        .format(),
      end: timestamp,
    });
  }

  return periods;
}

function Report(props) {
  // const [rangeSelected, setRangeSelected] = useState(null);

  // const periods = getDefaultPeriods();

  // const download = () => {
  //   props.getReport(rangeSelected).then(resp => {
  //     if (resp.type === GET_REPORT_REQ_RESULT) {
  //       const fileName = 'report_' + moment(rangeSelected).format('YYYYMMDD');
  //       downloadFileOnly(resp, fileName);
  //     } else {
  //       props.showNotification('ERROR');
  //     }
  //   });
  // };

  const downloadDevicesDetails = () => {
    const onDateSubmited = dates => {
      const request = {
        startDate: dates.startDate ? moment(dates.startDate * 1000).format() : undefined,
        endDate: dates.endDate ? moment(dates.endDate * 1000).format() : undefined,
        maxRangeAllowedMonths: 0,
      };
      props.getDevicesReportSummary(request.startDate, request.endDate).then(resp => {
        if (resp.type === GET_DEVICES_REPORT_REQ_RESULT) {
          const fileName = 'devices_report_' + moment(request.endDate).format('YYYYMMDD');
          downloadXlsx(resp, fileName);
        } else {
          props.showNotification('ERROR');
        }
      });
    };
    props.openDateRangeSelectionModal({
      actionOnDone: onDateSubmited,
      title: Strings.downloadDevicesDetails,
      submitButtonText: Strings.download,
    });
  };

  const downloadInvoicingData = () => {
        const onDateSubmited = dates => {
      const request = {
        startDate: dates.startDate ? moment(dates.startDate * 1000).format() : undefined,
        endDate: dates.endDate ? moment(dates.endDate * 1000).format() : moment().format(),
        maxRangeAllowedMonths: 0,
      };
      props.getDevicesReportInitial(request.startDate, request.endDate).then(resp => {
        if (resp.type === GET_DEVICES_REPORT_INITIAL_REQ_RESULT) {
          const fileName = 'devices_report_initial_' + moment(request.endDate).format('YYYYMMDD');
          downloadFileOnly(resp, fileName);
        } else {
          props.showNotification('ERROR');
        }
      });
      props.getDevicesReportRecurring(request.startDate, request.endDate).then(resp => {
        if (resp.type === GET_DEVICES_REPORT_RECURRING_REQ_RESULT) {
          const fileName = 'devices_report_recurring_' + moment(request.endDate).format('YYYYMMDD');
          downloadFileOnly(resp, fileName);
        } else {
          props.showNotification('ERROR');
        }
      });
    };
    props.openDateRangeSelectionModal({
      actionOnDone: onDateSubmited,
      title: Strings.downloadInvoicingData,
      submitButtonText: Strings.download,
    });
  };

  const rightHeader = (
    <DropdownMenu
      title={Strings.actions}
      options={[
        // { onSelect: download, label: Strings.downloadSummary, disabled:!rangeSelected },
        { onSelect: downloadDevicesDetails, label: Strings.downloadDevicesDetails },
        { onSelect: downloadInvoicingData, label: Strings.downloadInvoicingData },
      ]}
    />
  );

  return <ReportDashboard downloadActions={rightHeader} />;
}

Report.propTypes = {
  getReport: PropTypes.func.isRequired,
  showNotification: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  getReport: endDate => dispatch(actions.getReport(endDate)),
  getDevicesReportSummary: (startDate, endDate) => dispatch(actions.getDevicesReportSummary(startDate, endDate)),
  getDevicesReportInitial: (startDate, endDate) => dispatch(actions.getDevicesReportInitial(startDate, endDate)),
  getDevicesReportRecurring: (startDate, endDate) => dispatch(actions.getDevicesReportRecurring(startDate, endDate)),
  openDateRangeSelectionModal: data => dispatch(openModalAction('data-range-selection-modalion', data)),
  showNotification: (message, timeout) => dispatch(notificationActions.show(message, timeout)),
});

export default connect(null, mapDispatchToProps)(Report);

